// Sidebar.js
import React from "react";
import { Link } from "react-router-dom";
import { FaBoxOpen, FaClipboardList, FaCalendarAlt, FaImage, FaChartBar, FaFileAlt} from "react-icons/fa";

const Sidebar = () => {
  return (
    <div className="w-64 h-screen bg-gray-800 text-white fixed flex flex-col">
      <h2 className="text-2xl font-bold p-6 border-b border-gray-700">Admin Panel</h2>
      <nav className="flex flex-col gap-4 p-4">
        <Link to="/admin/inventory" className="flex items-center gap-2 p-3 rounded-lg hover:bg-gray-700">
          <FaBoxOpen /> Inventario
        </Link>
        <Link to="/admin/orders" className="flex items-center gap-2 p-3 rounded-lg hover:bg-gray-700">
          <FaClipboardList /> Pedidos
        </Link>
        <Link to="/admin/shipping" className="flex items-center gap-2 p-3 rounded-lg hover:bg-gray-700">
          <FaCalendarAlt /> Fechas
        </Link>
        <Link to="/admin/stats" className="flex items-center gap-2 p-3 rounded-lg hover:bg-gray-700">
          <FaChartBar /> Estadísticas
        </Link>
        <Link to="/admin/image-upload" className="flex items-center gap-2 p-3 rounded-lg hover:bg-gray-700">
          <FaImage /> Subir Imágenes
        </Link>
        <Link to="/admin/about-update" className="flex items-center gap-2 p-3 rounded-lg hover:bg-gray-700">
          <FaFileAlt /> Actualizar Sobre Nosotros
        </Link>
      </nav>
    </div>
  );
};

export default Sidebar;
